<template>
  <div class="ms-header" :class="{ 'home-page': isHomePage }">
    <!-- /Cookie -->
    <div v-if="!acceptCookies" id="cookie_notification" ref="notificationElement">
      <p>{{ $t('Наш сайт использует cookies') }}</p>
      <button @click="setCookies()" class="cookie_accept">{{ $t('Принять') }}</button>
    </div>

    <nav class="ms-nav">
      <div class="ms-logo">
        <a @click="goToHome" data-type="page-transition">
          <div class="logo-light current"><img :src="require('@/assets/logo-light.svg')" alt="logo image"></div>
        </a>
      </div>

      <div class="button-container" style="display: flex; align-items: center;">
        <div class="dropdown">
          <button class="dropdown-toggle" @click="isOpen = !isOpen">
            {{ (selectedLanguage || saveLocal).toUpperCase() }}
          </button>
          <ul class="dropdown-menu" v-if="isOpen">
            <li class="lang-menu" v-for="language in languages" :key="language.code">
              <button @click="selectLanguage(language)">
                {{ language.label }}
              </button>
            </li>
          </ul>
        </div>
        <button class="hamburger" type="button" data-toggle="navigation">
          <span class="hamburger-box"></span>
          <span class="hamburger-box">
            <span class="hamburger-label">{{ $t('Меню') }}</span>
            <span class="hamburger-inner"></span>
          </span>
        </button>
        <div class="height-full-viewport">
          <ul class="ms-navbar">
            <!-- Nav Link -->
            <li class="nav-item">
              <button @click="goToHome">
                <span class="ms-btn">{{ $t('Главная') }}</span>
                <span class="nav-item__label"></span>
              </button>
            </li>
            <!-- Nav Link -->
            <li class="nav-item">
              <button @click="goToNominees">
                <span class="ms-btn">{{ $t('эко-рейтинг') }}</span>
                <span class="nav-item__label"></span>
              </button>
            </li>
            <!-- Nav Link -->
            <li class="nav-item">
              <button @click="goToWinner">
                <span class="ms-btn">{{ $t('Победители') }}</span>
                <span class="nav-item__label"></span>
              </button>
            </li>
            <!-- Nav Link -->
            <li class="nav-item">
              <button @click="goToAbout">
                <span class="ms-btn">{{ $t('О премии') }}</span>
                <span class="nav-item__label"></span>
              </button>
            </li>
            <!-- Nav Link -->
            <li class="nav-item">
              <button @click="goToMetodics">
                <span class="ms-btn">{{ $t('Методология') }}</span>
                <span class="nav-item__label"></span>
              </button>
            </li>
            <!-- Nav Link -->
            <li class="nav-item">
              <button @click="goToContact">
                <span class="ms-btn">{{ $t('Контакты') }}</span>
                <span class="nav-item__label"></span>
              </button>
            </li>
          </ul>
        </div>
      </div>

    </nav>
  </div>

</template>

<script>
import {computed, ref} from "vue";
import {mapState, useStore} from "vuex";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";
import router from "@/router";

export default {
  name: "HeaderSite",
  setup() {
    const { locale } = useI18n({ useScope: 'global' })
    const store = useStore();
    const isOpen = ref(false)
    const notificationElement = ref(null);
    const selectedLanguage = ref(null)
    const acceptCookies = localStorage.getItem('saveCookies')
    const route = useRoute()

    const goToAbout = () => {
      const currentLocale = locale.value; // Получаем текущую локаль из состояния Vuex или другого источника
      router.push({ name: 'about', params: { locale: currentLocale } });
    }

    const goToNominees = () => {
      const currentLocale = locale.value; // Получаем текущую локаль из состояния Vuex или другого источника
      router.push({ name: 'scoring', params: { locale: currentLocale } });
    }

    const goToWinner = () => {
      const currentLocale = locale.value; // Получаем текущую локаль из состояния Vuex или другого источника
      router.push({ name: 'winner', params: { locale: currentLocale } });
    }

    const goToHome = () => {
      const currentLocale = locale.value; // Получаем текущую локаль из состояния Vuex или другого источника
      router.push({ name: 'home', params: { locale: currentLocale } });
    }

    const goToMetodics = () => {
      const currentLocale = locale.value;
      router.push({ name: 'metodics', params: { locale: currentLocale } });
    }

    const goToContact = () => {
      const currentLocale = locale.value; // Получаем текущую локаль из состояния Vuex или другого источника
      router.push({ name: 'contact', params: { locale: currentLocale } });
    }

    const languages = [
      { code: 'en', label: 'EN' },
      { code: 'fr', label: 'FR' },
      { code: 'es', label: 'ES' },
      { code: 'ru', label: 'RU' },
      { code: 'ar', label: 'AR' },
      { code: 'zh', label: 'ZH' }
    ]

    const selectLanguage = (language) => {
      const currentRoute = router.currentRoute.value;
      let path = currentRoute.path;

      // Ищем сегмент пути, который является языковым кодом
      const pathSegments = path.split('/');
      const localeIndex = pathSegments.findIndex(seg => languages.some(lang => lang.code === seg));

      if (localeIndex !== -1) {
        // Заменяем найденный языковой сегмент на новый
        pathSegments[localeIndex] = language.code;
        path = pathSegments.join('/');
      } else {
        // Локали нет в пути — добавляем в конец
        path = path === '/' ? `/${language.code}` : `${path}/${language.code}`;
      }

      // Обновляем состояние локали
      selectedLanguage.value = language.label;
      isOpen.value = false;
      store.commit('setLocale', language.code);
      locale.value = language.code;

      // Перенаправляем пользователя на новый путь
      router.replace({ path });
    };


    const setCookies = () => {
      localStorage.setItem('saveCookies', "accept")
      notificationElement.value.style.display = 'none';
    }

    const currentPath = computed(() => {
      return route.path
    })

    const isHomePage = computed(() => {
      return currentPath.value === '/' || currentPath.value.startsWith('/' + locale.value);
    });

    return {
      isOpen,
      selectedLanguage,
      languages,
      selectLanguage,
      setCookies,
      acceptCookies,
      notificationElement,
      currentPath,
      isHomePage,
      goToAbout,
      goToNominees,
      goToWinner,
      goToHome,
      goToContact,
      goToMetodics
    }
  },
  computed: {
    ...mapState({
      saveLocal: "saveLocal"
    })
  },
  mounted() {
    const hamburger = document.querySelector('.hamburger');
    const nav = document.querySelector('.ms-nav');

    hamburger.addEventListener('click', function() {
      this.classList.toggle('is-active');
      nav.classList.toggle('is-visible');
      document.querySelectorAll('.ms-header:not(.navbar-white) .logo-light').forEach(function(logo) {
        logo.classList.toggle('active');
      });
    });

    const heightFullViewport = document.querySelector('.height-full-viewport');
    heightFullViewport.addEventListener('mousewheel', function(e) {
      if (e.target.id === 'el') return;
      e.preventDefault();
      e.stopPropagation();
    });
  }
}
</script>

<style scoped lang="scss">
.ms-header {
  width: 100%;
  z-index: 3;
}

.ms-header.home-page {
  /* стили для главной страницы */
  position: fixed;
}

.ms-nav {
  display: flex;
  align-items: center;
  padding: 2em 3em;
  justify-content: space-between;
}

ul {
  list-style-type: none;
  list-style: none;
  padding-left: 0 !important;
  -webkit-padding-start: initial !important;
  -moz-padding-start: initial;
}

.ms-logo {
  position: relative;
  z-index: 7;
  height: 60px;
  cursor: pointer;
}

.logo-light {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity .3s ease .4s;
}

.logo-light.current {
  opacity: 1;
}
.ms-logo img {
  width: auto;
  height: 100%;
}

button {
  background: transparent;
  border: none;
}

.hamburger {
  margin-left: 60px;
  overflow: visible;
  cursor: pointer;
  z-index: 7;
  border: 0;
  transition-timing-function: linear;
  transition-duration: .3s ease;
  transition-property: opacity, -webkit-filter;
  transition-property: opacity, filter;
  transition-property: opacity, filter, -webkit-filter;

}
.navbar-white .hamburger-label {
  color: #fff;
}
.hamburger-label {
  display: block;
  font-family: 'Open Sans', Arial;
  font-size: 16px;
  width: 100%;
  height: auto;
  position: relative;
  top: 0;
  left: -4em;
  padding-right: 4em;
  text-transform: uppercase;
  line-height: 1.5em;
  transition: color .3s ease .4s;
  color: #fff;
}
.hamburger.is-active .hamburger-label {
  color: #fff !important;
  transition: color .1s ease;
}
.hamburger-box {
  position: relative;
  display: inline-block;
  width: 35px;
  vertical-align: middle;
}
.hamburger-inner {
  display: block;
  top: 0;
  margin-left: 2px;
}
.navbar-white .hamburger-inner,
.navbar-white .hamburger-inner:after,
.navbar-white .hamburger-inner:before {
  background-color: #fff;
}
.hamburger-inner:after,
.hamburger-inner:before {
  display: block;
  content: '';
}
.hamburger-inner,
.hamburger-inner:after,
.hamburger-inner:before {
  position: absolute;
  width: 30px;
  height: 3px;
  background-color: #fff;
  transition: all .3s ease .5s;
}
.hamburger-inner:before {
  top: 8px;
  left: -8px;
}
.hamburger-inner:after {
  top: 16px;
  width: 26px;
}
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner:after {
  background-color: #fff;
  transition-delay: .1s;
}
.hamburger.is-active .hamburger-inner {
  -webkit-transform: translate3d(0, 8px, 0) rotate(45deg);
  transform: translate3d(0, 8px, 0) rotate(45deg);
}
.hamburger.is-active .hamburger-inner:before {
  opacity: 0;
  transition: opacity .3s ease 0s
}
.hamburger.is-active .hamburger-inner:after {
  width: 30px;
  -webkit-transform: translate3d(0, -16px, 0) rotate(-90deg);
  transform: translate3d(0, -16px, 0) rotate(-90deg);
}

.height-full-viewport {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  left: 0;
  top: 0;
  width: 100%;
  height: 0%;
  background-color: #151515;
  z-index: 5;
  overflow: hidden;
  transition: height .8s cubic-bezier(0.3, 1, 0.3, 1) .1s;
}
.ms-navbar {
  z-index: 6;
  margin: 0 auto;
  display: block;
  width: auto;
  height: auto;
  top: 0;
  left: 0;
}
.ms-nav.is-visible .height-full-viewport {
  height: 100vh;
  transition: height 1s ease;
}
.nav-item {
  cursor: pointer;
  padding: .75em;
  opacity: 0;
  width: 270px;
  margin-left: 3em;
  transition: opacity .3s ease;
}
.ms-navbar a {
  display: block;
}
.ms-navbar .ms-btn {
  display: inline-block;
  text-transform: uppercase;
  line-height: 1;
  padding: 0 0.25em;
  position: relative;
}
.ms-navbar .ms-btn {
  font-size: 1.75em;
  letter-spacing: .02em;
  color: #fff;
  font-weight: 700 !important;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.ms-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #df1f29;
  height: .1rem;
  top: 50%;
  width: 0;
  transition: width .3s ease;
}
.nav-item__label {
  position: relative;
  display: block;
  margin: 0.5em 0 0 0;
  margin-top: 0.25em;
  padding: 0.5em;
  color: #555;
  transition: color .3s ease;
  text-decoration: none;
}
.nav-item:hover .nav-item__label {
  color: #9a9a9a;
}
.is-visible .nav-item {
  opacity: 1;
  transition: opacity 2s cubic-bezier(0.16, 1.08, 0.38, 0.98) .3s;
}
.nav-item .ms-btn {
  transition: all .3s ease;
}
.nav-item:active .ms-btn,
.nav-item:focus .ms-btn,
.nav-item:hover .ms-btn {
  color: #df1f29;
  opacity: 1;
  padding-left: 2.4rem;
}
.nav-item:active .ms-btn::before,
.nav-item:focus .ms-btn::before,
.nav-item:hover .ms-btn::before {
  width: 2rem;
}

.hamburger-inner {
  display: block;
  top: 0;
}
.navbar-white .hamburger-inner,
.navbar-white .hamburger-inner:after,
.navbar-white .hamburger-inner:before {
  background-color: #fff;
}
.hamburger-inner:after,
.hamburger-inner:before {
  display: block;
  content: '';
}
.hamburger-inner,
.hamburger-inner:after,
.hamburger-inner:before {
  position: absolute;
  width: 30px;
  height: 3px;
  background-color: #fff;
  transition: all .3s ease .5s;
}
.hamburger-inner:before {
  top: 8px;
  left: -8px;
}
.hamburger-inner:after {
  top: 16px;
  width: 26px;
}
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner:after {
  background-color: #fff;
  transition-delay: .1s;
}
.hamburger.is-active .hamburger-inner {
  -webkit-transform: translate3d(0, 8px, 0) rotate(45deg);
  transform: translate3d(0, 8px, 0) rotate(45deg);
}
.hamburger.is-active .hamburger-inner:before {
  opacity: 0;
  transition: opacity .3s ease 0s
}
.hamburger.is-active .hamburger-inner:after {
  width: 30px;
  -webkit-transform: translate3d(0, -16px, 0) rotate(-90deg);
  transform: translate3d(0, -16px, 0) rotate(-90deg);
}
.hamburger-label {
  display: block;
  font-family: 'Open Sans', Arial;
  font-size: 16px;
  width: 100%;
  height: auto;
  position: relative;
  top: 0;
  left: -4em;
  padding-right: 4em;
  text-transform: uppercase;
  line-height: 1.5em;
  transition: color .3s ease .4s;
  color: #fff;
}
.hamburger.is-active .hamburger-label {
  color: #fff !important;
  transition: color .1s ease;
}
.dropdown {
  margin-left: auto;
  overflow: visible;
  cursor: pointer;
  z-index: 7;
}
.dropdown-menu {
  position: absolute;
}
.lang-menu {
  margin: 7px 0;
  cursor: pointer;
}
button {
  color: white;
  font-family: 'Open Sans', Arial;
  font-size: 16px;
  cursor: pointer;
}
/* Cookie */

#cookie_notification{
  display: flex;
  align-items: center;
  position: fixed;
  top: 35px;
  left: 50%;
  max-width: 90%;
  transform: translateX(-50%);
  padding: 12px;
  background-color: #000;
  border-radius: 4px;
  box-shadow: 2px 3px 10px rgba(0, 0, 0, 0.4);
  z-index: 9;
}

#cookie_notification p{
  margin: 0;
  font-size: 0.7rem;
  text-align: left;
  color: #fff;
  padding-right: 15px;
}

@media (min-width: 576px){
  #cookie_notification.show{
    display: flex;
    color: #fff;
  }
  .cookie_accept{
    margin: 0 15px 0 10px;
    color: #fff;
    cursor: pointer;
  }
}

@media (max-width: 575px){
  #cookie_notification.show{
    display: block;
    text-align: left;
    color: #fff;
  }
  .cookie_accept{
    margin: 10px 0 0 0;
    color: #fff;
  }
}
</style>